import { lazy } from 'react';

export const StockList = lazy(() => import('./stock/StockList'));
export const AddStock = lazy(() => import('./stock/AddStock'));
export const StockAvailability = lazy(() => import('./stock/StockAvailability'));